"use client";

import { Minus, ThumbsDown, ThumbsUp } from "lucide-react";

interface RatingIconsProps {
  rating: string | null;
  onRate: (rating: string | null) => void;
}

const RATINGS = [
  { value: "liked", Icon: ThumbsUp, activeColor: "var(--accent-blue)" },
  { value: "disliked", Icon: ThumbsDown, activeColor: "var(--accent-red)" },
  { value: "maybe", Icon: Minus, activeColor: "var(--accent-yellow)" },
] as const;

export function RatingIcons({ rating, onRate }: RatingIconsProps) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
      {RATINGS.map(({ value, Icon, activeColor }) => {
        const isActive = rating === value;
        return (
          <button
            key={value}
            type="button"
            title={value}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onRate(isActive ? null : value);
            }}
            style={{
              display: "grid",
              placeItems: "center",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: "0.25rem",
              borderRadius: "4px",
              color: isActive ? activeColor : "var(--text-tertiary)",
              transition: "color 0.15s",
            }}
          >
            <Icon size={16} />
          </button>
        );
      })}
    </div>
  );
}
